const FaqMap = {
	Plural: 'FAQs',
	Single: 'FAQ',
	ModalForm: false,
	updateOrder: true,
	UpdateOrderMethod: "POST",
	UpdateOrderUseIds: true,
	DefaultSorting: 'order',
	DefaultSortingType: 'asc',
	Columns: [
		{
			name: '',
			label: '#',
			type: 'counter',
		},
		{
			name: 'id',
			dbName: 'id',
			label: 'ID',
			sortable: true,
			required: true,
			type: 'text',
		},
		{
			name: 'question',
			dbName: 'question',
			label: 'Question',
			sortable: true,
			required: true,
			type: 'text',
		},
		{
			name: 'answer',
			dbName: 'answer',
			label: 'Answer',
			sortable: false,
			required: true,
			type: 'text',
		},
		
	],
	Filters: [],
	PrimaryKey: 'id',
	Actions: {
		addLink: '/faq/add/',
		editLink: '/faq/edit/',
		deleteLink: '/faq/delete/',
	},
};

export default FaqMap;
